import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { ITechReferenceSheet } from '../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';
import BlankNote from '../../common/BlankNote';

export interface ITechReferenceSheetItemProps {
  agronomyReferenceSheet: ITechReferenceSheet;
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
}
class AgronomyReferenceSheetItem extends React.Component<ITechReferenceSheetItemProps> {

  constructor(props: any) {
    super(props);
  }

  render() {
    const className = `product-list-item product-list-img ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(this.props.isDragging!);
    return this.props.connectDragSource!(
      <li className={className}>
        {this.props.agronomyReferenceSheet.src === 'note' ? <BlankNote blankFlag={false}/> : <img src={this.props.agronomyReferenceSheet.src} title="" />}
      </li>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: props.agronomyReferenceSheet,
      type: placeholderTypes.Blank,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(AgronomyReferenceSheetItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/AgronomyReferenceSheetItem.tsx